export default __webpack_public_path__ + "static/media/CF.391fcfcf.svg";